/**
 * Maps a PREVIEW-STEP (`POST /pool/join-preview`) error code to one inline
 * sentence, shown under the invite-code field, never through the shared
 * error modal.
 *
 * A failed `POST /pool/join` (the commit step) does NOT come here. It routes
 * through the shared API error bus in `../../errors/apiErrorBus` instead, per
 * the split decided in the plan's `## 5.6`. These preview codes must never be
 * sent to the modal.
 */

export function joinPoolErrorCopy(code: string | null | undefined): string {
  switch (code) {
    case "POOL_CODE_NOT_FOUND":
      return "We couldn't find a pool with that invite code. Check it and try again.";
    case "POOL_CODE_EXPIRED":
      return "That invite code is no longer active. Ask the Commissioner for the current one.";
    case "VALIDATION_ERROR":
      return "We couldn't find a pool with that invite code. Check it and try again.";
    default:
      return "Something went wrong. Try again in a moment.";
  }
}

export const JOIN_OFFLINE_MESSAGE =
  "You're offline. Check your connection and try again.";
